import { createSlice } from '@reduxjs/toolkit';
import {
  getPortfolioTeams,
  deletePortfolioTeam,
} from '../thunk/portfolioComapniesThunk';
const initialState = {
  portfolioTeams: null,
  loading: false,
  updating: false,
  error: null,
};

const portfolioTeamsSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    clearPortfolioCompanyDetails: (state) => {
      state.portfolioCompanyDetails = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Contact Details
      .addCase(getPortfolioTeams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPortfolioTeams.fulfilled, (state, action) => {
        state.loading = false;
        state.portfolioTeams = action.payload.data;
      })
      .addCase(getPortfolioTeams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Portfolio Company
      .addCase(deletePortfolioTeam.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePortfolioTeam.fulfilled, (state) => {
        state.loading = false;
        state.portfolioTeams = null; // Clear data on delete success
      })
      .addCase(deletePortfolioTeam.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPortfolioCompanyDetails } = portfolioTeamsSlice.actions;
export default portfolioTeamsSlice.reducer;
